export default "__VITE_ASSET__48a56d21__"